import {NewsHeadlineRecord, NewsHeadlineRecords} from "../../../models/NewsHeadlineRecord";
import {SecurityMap} from "../../../../security/common/map/SecurityMap";
import moment from "moment";

export function currentHeadlinesOnly(previous: SecurityMap<NewsHeadlineRecords>,
                                     changes: NewsHeadlineRecords): SecurityMap<NewsHeadlineRecords> {
    changes.forEach((change) => {
        const current = previous.getOrDefault(change, []);
        const sameDate = sameDayHeadlinesOnly(change, current);
        previous.set(change, sameDate);
    });

    return previous;
}

/* Only retain headlines that are for the same date as the most recently received or newer */
function sameDayHeadlinesOnly(latest: NewsHeadlineRecord, current: NewsHeadlineRecords): NewsHeadlineRecords {
    const latestDate = moment(latest.at);
    const filtered = current.filter((c) => latestDate.isSameOrAfter(c.at, "date"));
    return filtered.concat(latest);
}
